import React, { useEffect, useState } from "react";
import {
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import _ from "lodash";
import { getItem } from "../../../../services/inventory/itemService";
import Illustration from "../../../../partials/content/Illustration";
function SearchVariant({ itemID = 0, onCloseDialog, onSelectVariant }) {
  const [item, setItem] = useState({
    itemID: 0,
    itemVarValue: [],
  });
  const [varCodeList, setVarCodeList] = useState([]);
  const [itemVarValue, setItemVarValue] = useState([]);
  useEffect(() => {
    getItemData(itemID);
  }, [itemID]);

  return (
    <React.Fragment>
      {varCodeList.length ? (
        varCodeList.map((variant, index) => {
          return (
            <FormControl
              key={variant.varID}
              variant="outlined"
              size="small"
              margin="normal"
              fullWidth={true}
            >
              <InputLabel id={`variant-${variant.varID}`}>
                {variant.varName}
              </InputLabel>
              <Select
                name={`variant-${variant.varID}`}
                label={variant.varName}
                value={variant.value}
                onChange={(e) => handleSelectVariantValue(e, index)}
              >
                <MenuItem value="0">Select Variant</MenuItem>
                {item.itemVarValue.map((varValue) =>
                  variant.varID === varValue.varID ? (
                    <MenuItem key={varValue.ID} value={varValue.ID}>
                      {varValue.varValue}
                    </MenuItem>
                  ) : null
                )}
              </Select>
            </FormControl>
          );
        })
      ) : (
        <Illustration
          imageSource="INVIFO Inventory.png"
          description="No available Variant from this item yet!"
          guidance="Hint: once the item have variants, it will be displayed here"
          descriptionLeftIcon="fas fa-info-circle kt-font-warning"
          size="sm"
        ></Illustration>
      )}
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            onCloseDialog();
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
        {varCodeList.length ? (
          <button
            type="button"
            className="btn btn-primary btn-md btn-pill btn-bold"
            onClick={() => {
              handleSelectVariant();
            }}
          >
            <i className="fas fa-mouse-pointer"></i>
            Select
          </button>
        ) : null}
      </DialogActions>
    </React.Fragment>
  );

  async function getItemData(itemID) {
    const response = await getItem(itemID);
    const { data } = response.data;
    const varCodeListData = [];
    let variantList = [];
    if (data.item.itemVarValue.length > 0) {
      variantList = _.uniqBy(data.item.itemVarValue, "varID");
      variantList.forEach((variant) => {
        varCodeListData.push({
          varID: variant.varID,
          varName: variant.itemVariant.varName,
          value: "",
          valueName: "",
        });
      });
      setItemVarValue(data.item.itemVarValue);
      setVarCodeList(varCodeListData);
      setItem(data.item);
    }
  }
  function handleSelectVariant() {
    const totalLength = varCodeList.length - 1;
    let error = false;
    let varCode = "";
    let valueName = "";
    varCodeList.forEach((variant, index) => {
      if (variant.value !== "") {
        varCode += `${variant.varID}=${variant.value}`;
        valueName += variant.varName + " = " + variant.valueName;
        if (totalLength !== index) {
          varCode += "+";
          valueName += " ";
        }
      } else {
        error = true;
      }
    });
    if (!error) {
      onSelectVariant(varCode, valueName);
    }
  }

  function handleSelectVariantValue(e, index) {
    const valueSelected = _.find(itemVarValue, ["ID", e.target.value]);
    if (valueSelected) {
      const varCodeListClone = [...varCodeList];
      varCodeListClone[index].value = e.target.value;
      varCodeListClone[index].valueName = valueSelected.varValue;
      setVarCodeList(varCodeListClone);
    }
  }
}

export default SearchVariant;
